import './FooterMovil.css'
import React from 'react'
import  iconLnkedin  from '../../img/redesSociales/linkedin.svg'
import  iconFace   from '../../img/redesSociales/facebook.svg'
import  iconInsta  from '../../img/redesSociales/instagram.svg'
import  iconTwitter  from '../../img/redesSociales/twitter.svg'


function FooterMovil() {
    return (
        <div className='divFooter'>
            <p>INSTITUTO TECNOLÓGICO Y DE ESTUDIOS SUPERIORES DE MONTERREY, MÉXICO. {new Date().getFullYear()} </p>
            <p>&copy; {new Date().getFullYear()} TEC DE MONTERREY. ALL RIGHTS RESERVED</p>
            
            <a href='https://www.facebook.com/TecdeMonterrey/' target={"_blank"}><img src={iconFace}></img></a>
            <a href='https://twitter.com/tecdemonterrey' target={"_blank"}><img src={iconTwitter}></img></a>
            <a href='https://mx.linkedin.com/school/tecdemonterrey/' target={"_blank"}><img src={iconLnkedin}></img></a>
            <a href='https://www.instagram.com/tecdemonterrey/'target={"_blank"}><img src={iconInsta}></img></a>
        </div>
    )
}

export default FooterMovil